import { ConcreteEncodable } from "./ConcreteEncodable";

import { BulkAdminModelRequestImplEncoder } from "../../encoder/BulkAdminModelRequestImplEncoder";

import * as CubiqTS from "../../index";
import { BulkAdminModelRequest } from "../BulkAdminModelRequest";

export class BulkAdminModelRequestImpl extends ConcreteEncodable implements BulkAdminModelRequest {
  public static enType: string = "com.bcdfx.model.event.admin.BulkAdminModelRequestImpl";

  /*FID=1*/
  public entityType: string;
  /*FID=2*/
  public requests: Array<CubiqTS.AdminModelUpload> | null = null;
  /*FID=100*/
  public messageId: string;
  /*FID=200*/
  public brokerId: string;
  /*FID=300*/
  public secureToken: CubiqTS.SecureToken | null = null;
  /*FID=998*/
  public connectionSessionId: string;
  /*FID=999*/
  public proxySessionId: string;
  /*FID=10000*/
  public svrRxTime: CubiqTS.Long | null = null;
  /*FID=10001*/
  public svrTxTime: CubiqTS.Long | null = null;
  /*FID=10002*/
  public cliTxTime: CubiqTS.Long | null = null;
  /*FID=10003*/
  public cliRxTime: CubiqTS.Long | null = null;
  /*FID=10010*/
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = BulkAdminModelRequestImplEncoder.Instance;
    this.setEncodableType(BulkAdminModelRequestImpl.enType);
    this.messageId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      let r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  public toString(): string {
    return (
      "BulkAdminModelRequestImpl[" +
      "entityType=" +
      this.entityType +
      "requests=" +
      this.requests +
      "messageId=" +
      this.messageId +
      "brokerId=" +
      this.brokerId +
      "secureToken=" +
      this.secureToken +
      "connectionSessionId=" +
      this.connectionSessionId +
      "proxySessionId=" +
      this.proxySessionId +
      "svrRxTime=" +
      this.svrRxTime +
      "svrTxTime=" +
      this.svrTxTime +
      "cliTxTime=" +
      this.cliTxTime +
      "cliRxTime=" +
      this.cliRxTime +
      "sessionOnly=" +
      this.sessionOnly +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
